import {createStyles, makeStyles, Theme} from '@material-ui/core';
import {desktop, mobile} from '../../const/sizes';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            padding: mobile.contentLargerSpacing,
            minHeight: 'calc(100vh - 148px)',
        },
        title: {
            fontSize: 36,
            fontWeight: 'bold',
            marginBottom: 30,
        },
        emailField: {
            marginBottom: 24,
        },
        submitButton: {
            marginBottom: 24,
        },
        pageContent: {
            height: '100%',
        },
        [theme.breakpoints.up('sm')]: {
            title: {
                fontSize: 56,
            },
            container: {
                padding: desktop.contentLargerSpacing,
                width: '100%',
            },
            image: {
                width: 474,
            },
            submitButton: {
                width: 300,
            },
            pageContent: {
                flexWrap: 'nowrap',
            },
        },
    }),
);

export default useStyles;
